import { render, staticRenderFns } from "./ShowUser.vue?vue&type=template&id=c8f3f2e8&scoped=true&"
import script from "./ShowUser.vue?vue&type=script&lang=js&"
export * from "./ShowUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f3f2e8",
  null
  
)

export default component.exports